import { Controller } from '@hotwired/stimulus';

// The iframe starts at Grafana's PROSPECT login, which is quick and silent for a user logged into
// PROSPECT, and comes back to the dashboard. Grafana itself doesn't redirect to it (no auto_login),
// so opening Grafana directly shows its login page.
export default class extends Controller {
  static targets = ['iframe'];
  static values = { url: String };

  #boundOnKeydown = null;
  #kioskDisabled = false;

  connect() {
    this.iframeTarget.src = this.#throughLogin(this.urlValue);

    if (new URL(this.urlValue).searchParams.has('kiosk')) {
      this.#boundOnKeydown = this.#onKeydown.bind(this);
      window.addEventListener('keydown', this.#boundOnKeydown);
    }
  }

  disconnect() {
    this.#unsubscribeFromKeydown();
  }

  // Also wired as a click action on the hint's "Show Grafana menu" button. Escape only reaches
  // #onKeydown while focus stays on the parent page - once the user clicks into the (cross-origin)
  // Grafana iframe, the browser never bubbles its keyboard events out to us, so the button is the
  // only way left to disable kiosk mode.
  disableKiosk() {
    if (this.#kioskDisabled) return;

    this.#kioskDisabled = true;
    this.#unsubscribeFromKeydown();
    window.dispatchEvent(new Event('kiosk:disabled'));
    this.iframeTarget.src = this.#withoutKiosk(this.urlValue);
  }

  #onKeydown(event) {
    if (event.key === 'Escape') this.disableKiosk();
  }

  // redirectTo only takes a path within Grafana
  #throughLogin(urlString) {
    const url = new URL(urlString);
    return `${url.origin}/login/generic_oauth?redirectTo=${encodeURIComponent(url.pathname + url.search)}`;
  }

  #withoutKiosk(urlString) {
    const url = new URL(urlString, window.location.href);
    url.searchParams.delete('kiosk');
    return url.toString();
  }

  #unsubscribeFromKeydown() {
    if (!this.#boundOnKeydown) return;
    window.removeEventListener('keydown', this.#boundOnKeydown);
    this.#boundOnKeydown = null;
  }
}
